import React from 'react';
import { Button, Icon, Form, Header, Segment, Loader, Table, Grid, Popup, Checkbox, Divider } from 'semantic-ui-react';
import axios from 'axios';
import ReactExport from 'react-data-export';
import moment from "moment";
import SearchTableData from "../util/SearchTableData";
import PaginationFront from "../util/PaginationFront";

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class EmployeesWithOUEInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            report: null,
            orgUnit: null,
            orgUnits: [],
            excelData: [],
            disabled: false,
            employeeTypeId: null,
            allTypes: false,
            disabledType: false,

            loaded: null,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],


            unsa: localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja' || localStorage.getItem('activeRole').substr(0, 13) === 'Administrator',

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
        };

            axios.get(this.state.organizationalUnitId === 0 ? `hr-reports/employee-with-oue-info/for-university/${this.state.employeeTypeId}/`
                : this.state.unsa ? `hr-reports/employee-with-oue-info/by-organizational-unit/${this.state.organizationalUnitId}/${this.state.employeeTypeId}/`
                : `hr-reports/employee-with-oue-info/${this.state.employeeTypeId}/`)
                .then(res => {
                    this.setState({
                        data: res.data.map(el => ({
                            ...el,
                            dateStart: el.mainDateStart ? moment(el.mainDateStart).format('D. M. YYYY.') : '',
                            dateEnd: el.mainDateEnd ? moment(el.mainDateEnd).format('D. M. YYYY.') : '',
                            otherOU: el.nonMainOrganizationalUnitsInfo.length ? el.nonMainOrganizationalUnitsInfo.map(e => (
                                e.organizationalUnitName + ":" + e.workTime + "% " + (e.dateStart ? moment(e.dateStart).format('D. M. YYYY.') : "/") + " - " + (e.dateEnd ? moment(e.dateEnd).format('D. M. YYYY.') : "/")
                            )).join(', ') : ''
                        })),
                        loaded: true,
                    }, ()=>{
                        this.setState({
                            excelData:  this.state.data.map(el => ([
                                { value: el.lastName},
                                { value: el.firstName},
                                { value: el.mainOrganizationalUnitName},
                                { value: el.dateStart},
                                { value: el.dateEnd},
                                { value: el.mainWorkTime},
                                { value: el.otherOU},
                            ]))})
                    });
                    console.log('excelData', this.state.excelData)

                });
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData:  this.state.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.mainOrganizationalUnitName},
                    { value: el.dateStart},
                    { value: el.dateEnd},
                    { value: el.mainWorkTime},
                    { value: el.otherOU},
                ]))});
        }else{
            this.setState({ results,
                excelData:  results.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.mainOrganizationalUnitName},
                    { value: el.dateStart},
                    { value: el.dateEnd},
                    { value: el.mainWorkTime},
                    { value: el.otherOU},
                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Matična organizaciona jedinica', width: { wpx: 200 } },
                    { title: 'Početak angažmana', width: { wpx: 150 } },
                    { title: 'Prestanak angažmana', width: { wpx: 150 } },
                    { title: 'Radno vrijeme (%)', width: { wpx: 150 } },
                    { title: 'Angažmani na drugim OJ', width: { wpx: 500 } },
                ],
                data: this.state.excelData,
            }
        ];
        return (
            <div>

                <Form>
                    <Form.Group widths="equal">

                        {this.state.unsa && <Form.Field disabled={this.state.disabled}>
                            <label>Organizaciona jedinica</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite organizacionu jedinicu"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        <Form.Field  disabled={this.state.allTypes}>
                            <label>Tip osoblja</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite tip osoblja"
                                value={this.state.employeeTypeId}
                                onChange={this.handleInputChange}
                                name="employeeTypeId"
                                options={this.props.employeeTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        {!this.state.unsa && <Form.Field />}
                    </Form.Group>

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj</Button>

                </Form>
                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={14}>
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['lastName', 'firstName', 'mainOrganizationalUnitName', 'dateStart', 'dateEnd', 'mainWorkTime', 'otherOU']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile
                                                    filename="Podaci o zaposlenicima sa njihovim angažmanima"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={multiDataSet} name="Zaposlenici" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={3} >Prezime i ime</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3} >Matična organizaciona jedinica</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}  >Početak angažmana</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}  >Prestanak angažmana</Table.HeaderCell>
                                    <Table.HeaderCell >Radno vrijeme (%)</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3} >
                                        <Header as="h4" image>
                                            <Header.Content>Angažmani na drugim OJ
                                                <Header.Subheader>početak angažmana - prestanak angažmana</Header.Subheader>
                                            </Header.Content>
                                        </Header>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell colSpan={3} verticalAlign="middle" > {el.lastName + " "} {el.firstName}</Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle" > {el.mainOrganizationalUnitName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.dateStart}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.dateEnd}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.mainWorkTime}</Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle" >

                                            {el.nonMainOrganizationalUnitsInfo.length ? el.nonMainOrganizationalUnitsInfo.map(e=>(
                                                <div><b>{e.organizationalUnitName + ":"}</b> ({e.workTime}%)<br/> {e.dateStart ? moment(e.dateStart).format('D. M. YYYY.') : '/'} -  {e.dateEnd ? moment(e.dateEnd).format('D. M. YYYY.') : '/'} <br/><br/></div>)) : null}

                                    </Table.Cell>

                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/EmployeesWithOUEInfo.js